import AutomationProductsRequests from '../../server/automationProducts';
import { addLoading, removeLoading } from './loading';

export const getListAutomationProducts = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AutomationProductsRequests.getListAutomationProducts(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getOptionsAutomationProduct = (limit, search) => async () => {
  const optionsProducts = await AutomationProductsRequests.getOptionsAutomationProduct(limit, search);
  return optionsProducts;
};

export const getCsvAutomationProduct = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AutomationProductsRequests.getCsvAutomationProduct();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCsvAutomationProduct = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AutomationProductsRequests.uploadCsvAutomationProduct(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const createAutomationProducts = newAutomationProducts => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AutomationProductsRequests.createAutomationProducts(newAutomationProducts);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateAutomationProducts = updAutomationProducts => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await AutomationProductsRequests.updateAutomationProducts(updAutomationProducts);
  } finally {
    dispatch(removeLoading());
  }
};
